import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Shared {
   private closeFeedbackSubject = new BehaviorSubject<boolean>(false);

  closeFeedback$ = this.closeFeedbackSubject.asObservable();

  closeFeedback(flag: boolean) {
    this.closeFeedbackSubject.next(flag);
  }
}
